import Confetti from "react-dom-confetti";
import React, { useRef, useState, useEffect } from "react";
import { CenteredLayout } from "components/layouts/CenteredLayout";
import { useHistory } from "react-router-dom";

import { getGlicko } from "utils/glicko";
import { Graph } from "components/Graph";
import { useAuth } from "hooks/useAuth";
import { useCompare } from "hooks/usePrevious";
import "./SummaryPage.scss";

function SummaryPage(props) {
  const { trials } = useAuth();
  const history = useHistory();

  if (!trials) {
    return <CenteredLayout />;
  }

  const isPreview = props.match.params.levelUp !== undefined;
  const isPreviewUp = props.match.params.levelUp === "true";
  const length = !isPreview ? props.match.params.length : 10;
  const glickoHistory = getGlicko(trials).slice(-1 - length);
  const from = !isPreview ? glickoHistory[0] : 0;
  const to = !isPreview ? glickoHistory[glickoHistory.length - 1] : 0;
  const correctAnswers = !isPreview
    ? trials
        .slice(-1 * length)
        .reduce((acc, { isCorrect }) => acc + Boolean(isCorrect), 0)
    : 0;

  return (
    <CenteredLayout>
      <Summary
        from={from}
        to={to}
        levelUp={isPreview ? isPreviewUp : from <= to}
        correctAnswers={correctAnswers}
        glickoHistory={glickoHistory}
        onClick={() => {
          if (isPreview) {
            history.push({
              pathname: `/summary/preview/${String(!isPreviewUp)}`
            });
          } else {
            history.push({
              pathname: `/`
            });
          }
        }}
        history={history}
      />
    </CenteredLayout>
  );
}

const HAPPY_EMOJIS = ["✨", "🚀", "🏃", "💪", "👍", "😉", "🍾", "🥂", "🙌"];
const HAPPY = [
  "Beautiful",
  "Congratulations",
  "Excellent",
  "Good going",
  "Good job",
  "Good work",
  "Great ",
  "Keep it up ",
  "Muy bien",
  "Neat",
  "Nice going",
  "Outstanding",
  "Right on",
  "Super",
  "Terrific",
  "That's it",
  "Way to go",
  "Well done",
  "You've got it"
];
const SAD = [
  "Bad luck 🍀",
  "Hard luck 🍀",
  "Never mind 😓",
  "Hard cheese 🧀",
  "Tough noogies 😅",
  "Tough luck 🍀"
];

function Summary(props) {
  const [confetti, setConfetti] = useState(false);
  const { current: happyString } = useRef(
    `${pickOne(HAPPY)} ${pickOne(HAPPY_EMOJIS)}`
  );
  const { current: sadString } = useRef(pickOne(SAD));
  const [hasRendered, setHasRendered] = useState();
  const hasChanged = useCompare(hasRendered);
  useEffect(() => {
    if (hasChanged && hasRendered) {
      setConfetti(props.levelUp);
      const audio = new Audio(props.levelUp ? "/tada.mp3" : "/ohnoes.mp3");
      audio.volume = 0.5;
      audio.play();
    }
  }, [props.levelUp, hasChanged, hasRendered]);
  return (
    <div
      className={`summary-page ${props.levelUp ? "levelUp" : "levelDown"}`}
      onClick={props.onClick}
      ref={el => {
        if (el) {
          window.analytics.track("session.ended", {
            levelUp: props.levelUp,
            correctAnswers: props.correctAnswers
          });
        }
      }}
    >
      <div className={`overlay ${props.levelUp ? "levelUp" : "levelDown"}`}>
        &nbsp;
      </div>
      <h1 className={props.levelUp ? "slideDown" : "slideUp"}>
        {props.levelUp ? happyString : sadString}
      </h1>
      <p>
        You got {props.correctAnswers || "no"}{" "}
        {props.correctAnswers === 1 ? "answer" : "answers"} right
        <br />
        {props.levelUp ? "and " : props.correctAnswers ? "but " : "and "} your
        rating went {props.to >= props.from ? "up" : "down"} from {props.from}{" "}
        to {props.to}.
      </p>
      <Confetti
        ref={setHasRendered}
        className="confetti"
        active={confetti}
        config={{
          angle: 90,
          spread: 45,
          startVelocity: 45,
          elementCount: 50,
          dragFriction: 0.1,
          duration: 3000,
          stagger: "0",
          width: "10px",
          height: "10px",
          colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"]
        }}
      />
      <Graph
        colors={[props.levelUp ? "#0f0d" : "#f00d"]}
        data={props.glickoHistory.reduce(
          (acc, glicko, i) => ({ ...acc, [i]: glicko }),
          {}
        )}
      />
      <p style={{marginTop: '3rem', fontSize: 'large', color: '#fffa'}}>Click anywhere to continue</p>
    </div>
  );
}

function pickOne(array) {
  return array[Math.ceil(Math.random() * array.length) - 1];
}

export { SummaryPage };
